import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ModalWindowModule } from 'ag-common-svc/lib/components';
import { DxSelectBoxModule, DxValidatorComponent } from 'devextreme-angular';
import { UpdateInviteeOutcomeStatusModalComponent } from './update-invitee-outcome-status-modal.component';
import { UpdateInviteeOutcomeStatusModalService } from './update-invitee-outcome-status-modal.service';

@NgModule({
  imports: [CommonModule, SharedModule, ModalWindowModule, DxSelectBoxModule, DxValidatorComponent],
  declarations: [UpdateInviteeOutcomeStatusModalComponent],
  exports: [UpdateInviteeOutcomeStatusModalComponent],
  providers: [UpdateInviteeOutcomeStatusModalService],
})
export class UpdateInviteeOutcomeStatusModalModule {}
